import { render, staticRenderFns } from "./DirectSdsOrder.vue?vue&type=template&id=5fa78471&scoped=true&"
import script from "./DirectSdsOrder.vue?vue&type=script&lang=js&"
export * from "./DirectSdsOrder.vue?vue&type=script&lang=js&"
import style0 from "./DirectSdsOrder.vue?vue&type=style&index=0&id=5fa78471&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa78471",
  null
  
)

export default component.exports